module.exports = __webpack_public_path__ + "static/media/linkedin-light.a10a7b29.svg";